import { render, staticRenderFns } from "./BaseMatchupBlock.vue?vue&type=template&id=cf67e888&scoped=true"
import script from "./BaseMatchupBlock.vue?vue&type=script&lang=ts"
export * from "./BaseMatchupBlock.vue?vue&type=script&lang=ts"
import style0 from "./BaseMatchupBlock.vue?vue&type=style&index=0&id=cf67e888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf67e888",
  null
  
)

export default component.exports